import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  data: function data() {
    return {
      dayjs: dayjs,
      structures_list: [],
      weatherData: [],
      formData: {},
      editDialogShow: false,
      formLabelWidth: '120px',
      handleData: {},
      handleRules: {
        operateDate: [{
          required: true,
          message: '请选择操作日期',
          trigger: 'blur'
        }],
        operateContent: [{
          required: true,
          message: '请输入操作内容',
          trigger: 'blur'
        }]
      },
      handleDialogShow: false,
      category: {
        Custom: '计划任务',
        Clean: '清塘',
        Stock: '投苗',
        Inspection: '巡塘',
        Feed: '投喂',
        Split: '分塘',
        Breed: '繁育',
        Medication: '施药',
        Disease: '病害',
        Harvest: '捕捞'
      }
    };
  },
  mounted: function mounted() {
    this.getLabArea();
    this.getWeatherData();
  },
  methods: {
    // 获取养殖池
    getLabArea: function getLabArea() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, index, taskList;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api['labAreaQuery']({
                labId: localStorage.getItem('labId'),
                sortField: '^sort',
                searchKey: 'Cistern,Pond,Lake'
              });
            case 2:
              res = _context.sent;
              if (!res.data) {
                _context.next = 14;
                break;
              }
              _this.structures_list = res.data || [];
              _context.t0 = _regeneratorRuntime().keys(_this.structures_list);
            case 6:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 14;
                break;
              }
              index = _context.t1.value;
              _context.next = 10;
              return _this.getTask(_this.structures_list[index].id);
            case 10:
              taskList = _context.sent;
              _this.$set(_this.structures_list[index], 'taskList', taskList);
              _context.next = 6;
              break;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getTask: function getTask(areaId) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$api['taskQuery']({
                page: 1,
                limit: 4,
                labId: localStorage.getItem('labId'),
                areaId: areaId
              });
            case 2:
              res = _context2.sent;
              return _context2.abrupt("return", res.data || []);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getWeatherData: function getWeatherData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.$api['labWeather'](localStorage.getItem('labInfo') ? JSON.parse(localStorage.getItem('labInfo')).districtCode || '650400' : '370200');
            case 2:
              res = _context3.sent;
              _this3.weatherData = JSON.parse(res.data).result.now;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    handle: function handle(id) {
      this.handleData = {
        id: id
      };
      this.handleDialogShow = true;
    },
    submitHandleData: function submitHandleData() {
      var _this4 = this;
      this.$refs['handleformDataVerify'].validate(function (valid) {
        if (valid) {
          _this4.$api['taskHandle'](_this4.handleData.id, _this4.handleData).then(function (res) {
            if (res.data) {
              _this4.$message.success('操作成功');
              _this4.handleDialogShow = false;
              _this4.handleData = {};
              _this4.getLabArea();
            } else {
              _this4.$message.error('操作失败');
            }
          });
        }
      });
    },
    look: function look(data) {
      this.formData = JSON.parse(JSON.stringify(data));
      if (data.executeDate) {
        this.$set(this.formData, 'executeDate', dayjs(data.executeDate).format('YYYY-MM-DD HH:mm:ss'));
      }
      this.editDialogShow = true;
    },
    backClick: function backClick() {
      this.$router.back();
    }
  }
};